export const NON_STOP_MATCH = 'NON_STOP_MATCH';
export const SHUFFLED_MESSAGE = 'CardResult';
export const TURBO_GAME_ID = 66666665;
export const SHUFFLE_CARDS_COUNT = new Array(45).fill(null).map((item, index) => index);
export const GAME_RULES_HELP_KEYS = new Array(20).fill(null).map((item, index) => index);
